import React, { useContext, useEffect, useState } from "react";
import AllCompetitors from "./AllCompetitors";
import "./Competitors.css";
import { useUser } from "../../../context/UserContext";

export default function Competitors() {
  const { user } = useUser();

  return (
    <div className="container-fluid">
      <div className="row">
        <AllCompetitors user={user} />
      </div>
    </div>
  );
}
